export const isIncluded = <T extends string | number>(
  v: string | number,
  list: T[] | readonly T[]
): v is T => list.some((item) => item === v)
